<template>
  <div>
    <Breadcrumbs></Breadcrumbs>
    <div class="faqs answer">
      <b-row class="justify-content-md-center boxes faq-search-container">
        <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
          <FaqSearchBox></FaqSearchBox>
        </b-col>
      </b-row>
      <div v-if="selectedFaq" class="answer-faqs">
        <StepTitle>{{ selectedFaq.question }}</StepTitle>
        <div class="faq-outer-container mt-3">
          <div>
            <b-row class="boxes">
              <b-col md="12">
                <div class="faq-container">
                  <b-row>
                    <b-col>
                      <p v-html="selectedFaq.answer" class="answer-text"></p>
                    </b-col>
                  </b-row>
                  <div class="thumb">
                    <span>
                      <b-link class="question-answered q_links" @click="vote(selectedFaq, true)"><font-awesome-icon
                        :icon="['far', 'thumbs-up']"></font-awesome-icon> This answers my question</b-link>
                    </span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="des-yes-no">
              <b-row class="justify-content-md-center mr-0 mb-4 ml-0">
                <div class="buttons-orders">
                  <p> Did this help? </p>
                  <b-row class="desk-yes-no justify-content-md-center">
                    <b-col cols="2">
                      <b-button @click="vote(selectedFaq, false)" variant="success"
                                class=" no-btn btn-width des-no custom-no">
                        <span class="no-svg"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon></span>
                        No
                      </b-button>
                    </b-col>
                    <b-col cols="2">
                      <b-button @click="vote(selectedFaq, true)" variant="success"
                                class="yes-btn btn-width des-yes custom-yes">
                        <span class="yes-svg"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon></span>
                        Yes
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-row>
            </div>
            <!-- YES AND NO BUTTONS FOR MOBILE -->
            <div class="mob-yes-no">
              <b-row class="justify-content-md-center mr-0 ml-0">
                <div class="buttons-orders sticky-div">
                  <p> Did this help? </p>
                  <b-row>
                    <b-col cols="5" offset="1" class="mob-yes-no-btn">
                      <b-button @click="vote(selectedFaq, false)" variant="success" class="no-btn btn-width ">
                        <span class="no-svg"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon></span>
                        No
                      </b-button>
                    </b-col>
                    <b-col cols="5" offset="" class="mob-yes-no-btn">
                      <b-button @click="vote(selectedFaq, true)" variant="success" class="yes-btn btn-width">
                        <span class="yes-svg"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon></span>
                        Yes
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-row>
            </div>
            <section class="boxes update-back-btn">
              <b-row class="justify-content-md-center">
                <b-col md="4">
                  <b-button block @click="goBack()" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
                </b-col>
              </b-row>
            </section>
          </div>
        </div>
      </div>
      <div class="answer-footer" v-if="relatedFaqs.length > 0">
        <h3 class="position-relative zIndex">Related Questions...</h3>
        <b-row class="questions justify-content-md-center position-relative zIndex" >
          <template v-for="faq in relatedFaqs">
            <b-col v-if="selectedFaq && faq && faq.id !== selectedFaq.id" :key="'faq-' + faq.id" md='4' class="related-q-p">
              <router-link class="faq-link" :to="{ name: 'faq-details', params: { pk: faq.id, slug: faq.slug }}" custom>
                <b-card :title="faq.question" sub-title="" class="my-faq-card-two rel-faq-card h-100">
                  <b-card-text v-html="getShortAnswer(faq)" class="footer-card-answer">
                  </b-card-text>
                  <font-awesome-icon :icon="['far', 'thumbs-up']" class="faq-qtn-icon" @click="vote(faq, true)"></font-awesome-icon>
                </b-card>
              </router-link>
            </b-col>
          </template>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import { InputType } from '../constants'
const StepTitle = () => import('./StepTitle')
const Breadcrumbs = () => import('@/components/Breadcrumbs')
const FaqSearchBox = () => import('@/components/FaqSearchBox')

export default {
  name: 'FaqDetails',
  computed: {
    ...mapState(['selectedFaq', 'relatedFaqs', 'votedFaqs', 'isIE', 'session'])
  },
  components: {
    FaqSearchBox,
    Breadcrumbs,
    StepTitle
  },
  watch: {
    $route: function(to, from) {
      this.init() // fetch new faq on route change
    },
    '$store.state.session': function(to, from) {
      if (to && !from) {
        this.init()
      }
    }
  },
  metaInfo: function() {
    let description = 'Faq Details'
    let keywords = null
    let metaInfo = {
      title: this.selectedFaq ? this.selectedFaq.question : 'Faq Details',
      meta: []
    }
    if (this.selectedFaq) {
      description = this.selectedFaq.meta_description || this.selectedFaq.answer
      keywords = this.selectedFaq.keywords
      const descriptionEl = document.createElement('div')
      descriptionEl.innerHTML = description
      description = descriptionEl.textContent || descriptionEl.innerText
      metaInfo.meta.push({name: 'description', content: description})
      metaInfo.meta.push({name: 'keywords', content: keywords || metaInfo.title})
    }
    return metaInfo
  },
  methods: {
    getShortAnswer: function(faq) {
      if (faq.blurb && faq.blurb.length) {
        return faq.blurb
      }

      let div = document.createElement('div')
      div.innerHTML = faq.answer

      return div.innerText
    },
    vote: function(faq, thumbsUp) {
      const path = thumbsUp ? 'upvote' : 'downvote'

      if (!(faq.id in this.votedFaqs)) {
        // faq not yet voted, so vote for it
        this.$store.commit('busy')
        axios.post('/faq/' + faq.id.toString() + '/' + path + '/', {})
          .then(_resp => {
            this.$store.commit('set_faq_vote', faq)
            this.$store.commit('ready')
          })
          .catch(err => {
            console.log(err)
            this.$store.commit('ready')
          })
      }
    },
    init: function() {
      if (!this.session || this.session.step_type !== InputType.Faqs) {
        this.$store.dispatch('start')
        this.$router.replace({name: 'session'})
        return
      }
      let slug = ''
      if ('slug' in this.$route.params) {
        slug = this.$route.params.slug
      }
      if (slug && slug.length) {
        this.$store.commit('busy')
        this.$store.dispatch('get_faq', {slug})
          .then(result => {
            this.$store.commit('ready')
          })
          .catch(err => {
            if (err.response && err.response.status === 302) {
              this.$router.replace({name: 'faq-details', params: {slug: err.response.data.slug}})
            } else {
              console.log(err)
              this.$router.replace({name: 'session'})
            }
          })
      } else {
        this.$router.replace({name: 'session'}) // ignore the jump and stay where we are in the session
      }
    },
    goBack: function() {
      this.$router.go(-1)
    }
  },
  created() {
    this.init()
  }
}
</script>

<style scoped>

</style>
